import { jsx as e, jsxs as l, Fragment as o } from "react/jsx-runtime";
import { CloseCircleIcon as d, SmallPenIcon as i } from "@systemeio/ui/icons";
import { CircularProgress as n } from "./circular-progress.mjs";
import { twMerge as t } from "tailwind-merge";
import { FileItemBase as a } from "./file-item-base.mjs";
function g(r) {
  return /* @__PURE__ */ e(
    a,
    {
      ...r,
      childrenFileWrapper: /* @__PURE__ */ e(
        "div",
        {
          className: t(
            "bg-background-secondary/20 absolute top-0 left-0 hidden h-full w-full cursor-auto items-center justify-center rounded-md backdrop-blur-md",
            r.showEditButton && !r.disabled && "group-hover/edit:lg:flex flex lg:hidden"
          ),
          children: /* @__PURE__ */ e("div", { onClick: r.onEdit, className: "group cursor-pointer p-2", children: /* @__PURE__ */ e(i, { className: "fill-background-secondary group-hover:fill-brand-primary main-transition-colors" }) })
        }
      ),
      childrenWrapper: /* @__PURE__ */ l(o, { children: [
        r.isError && /* @__PURE__ */ e("div", { className: "bg-background-secondary/20 absolute top-0 left-0 flex h-full w-full items-center justify-center rounded-md backdrop-blur-md", children: /* @__PURE__ */ e(d, { className: "fill-danger rounded-full" }) }),
        r.isLoading && /* @__PURE__ */ e("div", { className: "bg-background-secondary/20 absolute top-0 left-0 flex h-full w-full items-center justify-center rounded-md backdrop-blur-md", children: /* @__PURE__ */ e(n, { progress: r.progress ?? 0 }) })
      ] })
    }
  );
}
export {
  g as FileItemCompact
};
